<template>
  <div>
      <div class="expiry-text" :class="totalElePointExpiry <= 0 ? 'mb-2' : ''"><strong>3カ月以内に無効になるベネポ</strong></div>
      <div class="top-detail">
      <!-- <div class="date-picker">
        <span class="text-gray-500 mr-2 whitespace-nowrap">表示期間</span>
        <a-date-picker show-time clearable @change="getDateChange(1, $event)"/>
        <span class="self-center">&ensp;〜&ensp;</span>
        <a-date-picker show-time clearable @change="getDateChange(2, $event)"/>
        <button class="md:hidden ml-4 c-btn btn-sm btn-white btn" @click="getListPoint()" >
          絞り込む
        </button>
      </div> -->
      <!-- <div class="note">
        <p>
          ※ 過去3年分までの表示となります。<br />
          ※ 表示期間の範囲は1年以内を選択してください。
        </p>
      </div> -->
      <div class="pagination-contain">
        <p class="total" v-if="totalElePointExpiry"><strong>{{ totalElePointExpiry }}</strong>件中 
          <span v-if="page === 1 && totalElePointExpiry"> 1 </span>
          <span v-if="!totalElePointExpiry">0</span>
          <span v-if="page > 1"> {{ (page -1) * 10 + 1 }}</span>
          ～
          <span v-if="totalElePointExpiry <= 10"> {{ totalElePointExpiry }} </span>
          <span v-if="totalElePointExpiry > 10 && ((page - 1) * 10 < Math.floor(totalElePointExpiry/10)*10) "> {{ page * 10 }}</span>
          <span v-if="totalElePointExpiry > 10 && ((page - 1) * 10 >= Math.floor(totalElePointExpiry/10)*10 && (page - 1) * 10 < totalElePointExpiry) "> {{ (page -1) * 10 + totalElePointExpiry % 10}}</span>
          件表示
        </p>
        <Pagination class="pagination"
          @onChange="onChange"    
          :page="page"   
          :pageSize="5"
          :default-current="1"
          :totalRecord="totalElePointExpiry"

        />
      </div>
    </div>
    <a-divider />
    <div v-if="dataPage.length > 0" class="content-detail">
      <div v-for="(item, index) in dataPage" :key="index">
        <article>
          <p>{{ item.validTo }}に無効になるベネポ</p>
          <span>{{ item.point | formatInteger}}P</span>
        </article>
        <a-divider v-if="(index < dataPage.length - 1)" class="w-full aaa" />
      </div>
    </div>
    <div v-if="dataPage.length <= 0" class="pb-5">
      <a-list :data-source="[]" />
      <div class="text-center"> 
        <span class="text-blank">{{ descriptionImageBlank }}</span>
      </div>
    </div>  
    <a-divider v-if="dataPage > 0" />
  </div>
</template>

<script>

export default {
  data() {
    return {
      // is_hidden: true, 
      dateStr1: '',
      dateStr2: '',
      page: '',
      value1: '',
      descriptionImageBlank: '誠に申し訳ございませんが、データがありませんでした',
      dataPage: []
    }
  },
  mounted() {
  },
  watch: {
    listData() {
      this.onChange(1)
    }
  },
  props: {
    title: String,
    listData: Array,
    totalElePointExpiry: Number
  },
  methods: {
    onChange(page) {
      this.page = page
      this.dataPage = []
      this.listData.forEach((item, index) => {
        if((index >= ((page - 1) * 10)) && (index <= ((page * 10) - 1))) {
          this.dataPage.push(item)
        }
      })
      this.$emit('onChange', page)
    },
    getDateChange(index, $event) {
      switch (index) {
      case 1:
        this.dateStr1 = $event.format('YYYYMMDDTHHmmss+0900')
        break
      case 2:
        this.dateStr2 = $event.format('YYYYMMDDTHHmmss+0900')
      }
    },
    getListPoint() {
      const objDateStr = {
        dateStr1: this.dateStr1,
        dateStr2: this.dateStr2
      }
      this.$emit('getListPointNearExpDateByDate', objDateStr)
    }
   
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss"
</style>
